export default __webpack_public_path__ + "static/img3-5c912880f8f7c4a9aa11cdd9fe9d458f.png";